import React from 'react';
import Image from 'next/image';
import { Button } from 'reactstrap';
import styles from '../../../styles/common/features.module.css';

const TalkToUsCustomButtonUAE = ({ text, style, onClick, idx }) => {
  // Determine arrow color based on provided color or index
  const getArrowFilter = () => {
    const color = style?.color;
    
    // If color is provided, map it to the appropriate filter
    if (color) {
      const colorUpper = color.toUpperCase().trim();
      // Map known colors to their CSS filters
      const colorFilterMap = {
        '#2A6AB4': 'brightness(0) saturate(100%) invert(25%) sepia(77%) saturate(1234%) hue-rotate(201deg) brightness(95%) contrast(86%)', // Blue
        '#016A5E': 'brightness(0) saturate(100%) invert(25%) sepia(84%) saturate(926%) hue-rotate(135deg) brightness(94%) contrast(101%)', // Teal
        '#FFFFFF': 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(116deg) brightness(111%) contrast(111%)', // White
        '#FFF': 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(116deg) brightness(111%) contrast(111%)', // White (short)
        'WHITE': 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(116deg) brightness(111%) contrast(111%)', // White (text)
        '#112A48': 'brightness(0) saturate(100%) invert(12%) sepia(45%) saturate(1234%) hue-rotate(201deg) brightness(95%) contrast(95%)', // Dark blue
      };
      
      if (colorFilterMap[colorUpper]) {
        return colorFilterMap[colorUpper];
      }
      
      // For any other hex color, use a generic filter approach
      if (colorUpper.startsWith('#')) {
        // For custom colors, approximate with a generic filter
        // This is a simplified approach; for exact color matching, you'd need a color-to-filter converter
        return 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(116deg) brightness(111%) contrast(111%)'; // Default filter
      }
    }
    
    // Fallback to index-based logic if no color provided
    if (idx === 0) return 'brightness(0) saturate(100%) invert(25%) sepia(77%) saturate(1234%) hue-rotate(201deg) brightness(95%) contrast(86%)'; // Blue #2A6AB4
    if (idx === 2) return 'brightness(0) saturate(100%) invert(25%) sepia(84%) saturate(926%) hue-rotate(135deg) brightness(94%) contrast(101%)'; // Teal #016A5E
    if (idx % 2 !== 0) return 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7500%) hue-rotate(116deg) brightness(111%) contrast(111%)'; // White
    return 'brightness(0) saturate(100%) invert(34%) sepia(77%) saturate(1234%) hue-rotate(201deg) brightness(95%) contrast(86%)'; // Default blue
  };

  return (
    <div>
      <Button 
        className={`${styles.talk_custom_button}`}
        style={{
            display: 'flex',
          height: style?.height || "4.5rem",
          width: style?.width || "fit-content",
          fontSize: style?.fontSize || "1.5rem",
          backgroundColor: "transparent",
          border:"none",
          fontWeight: style?.fontWeight || 600,
          textDecoration: 'underline',
          textDecorationColor: style?.color || (idx === 0 ? '#2A6AB4' : idx === 2 ? '#016A5E' : idx % 2 !== 0 ? 'white' : '#2A6AB4'),
          ...style,
          color: style?.color || (idx === 0 ? '#2A6AB4' : idx === 2 ? '#016A5E' : idx % 2 !== 0 ? 'white' : '#2A6AB4'),
          
        }}
        onClick={(e) => {
          onClick ? onClick(e) : "";
        }}
      >
        {text}
        <div style={{position:'relative', width:"1.8rem", height:'1.5rem',marginTop:"0.5rem", filter: getArrowFilter()}}>
          <Image src='/assets/arrow_outward.svg' fill alt="arrow"/>
        </div>
      </Button>
    </div>
  );
};

export default TalkToUsCustomButtonUAE;
